/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconArrowBigDownLinesFilled = createReactComponent("filled", "arrow-big-down-lines-filled", "IconArrowBigDownLinesFilled", [["path", { "d": "M9 8l-.117 .007a1 1 0 0 0 -.883 .993v1.999l-2.586 .001a2 2 0 0 0 -1.414 3.414l6.586 6.586a2 2 0 0 0 2.828 0l6.586 -6.586a2 2 0 0 0 .434 -2.18l-.068 -.145a2 2 0 0 0 -1.78 -1.089l-2.586 -.001v-1.999a1 1 0 0 0 -1 -1h-6z", "key": "svg-0" }], ["path", { "d": "M15 2a1 1 0 0 1 .117 1.993l-.117 .007h-6a1 1 0 0 1 -.117 -1.993l.117 -.007h6z", "key": "svg-1" }], ["path", { "d": "M15 5a1 1 0 0 1 .117 1.993l-.117 .007h-6a1 1 0 0 1 -.117 -1.993l.117 -.007h6z", "key": "svg-2" }]]);

export { IconArrowBigDownLinesFilled as default };
//# sourceMappingURL=IconArrowBigDownLinesFilled.mjs.map
